import { getDealStatusBadgeClass } from "../Common/DealStatus";

export const dealColumns = ({
  selectedIds,
  handleSelect,
  handleSelectAll,
  totalRows,
}) => [
  {
    id: "select",
    label: (
      <input
        type="checkbox"
        checked={
          totalRows > 0 &&
          selectedIds.length === totalRows
        }
        onChange={handleSelectAll}
      />
    ),

    render: (deal) => (
      <input
        type="checkbox"
        checked={selectedIds.includes(deal.id)}
        onChange={() => handleSelect(deal.id)}
        onClick={(e) => e.stopPropagation()}
      />
    ),
  },
 
  {
    id: "Title",
    label: "Title",
 
    render: (deal) => (
      <div className="deal-info">
        <div className="deal-name">
          {deal.title || "-"}
        </div>
      </div>
    ),
 
    exportValue: (deal) => deal.title || "",
  },
 
  {
    id: "organization",
    label: "Organization",
 
    render: (deal) => (
      <div className="deal-info">
        <div className="deal-name">
          {deal.organization?.name || "-"}
        </div>
      </div>
    ),
 
    exportValue: (deal) => deal.organization?.name || "",
  },
 
  {
    id: "deal_amount",
    label: "Deal Amount",
 
    render: (deal) =>
      deal.deal_amount
        ? `₹${Number(deal.deal_amount).toLocaleString()}`
        : "₹0",
 
    exportValue: (deal) => deal.deal_amount || 0,
  },
 
  {
    id: "actual_expense",
    label: "Actual Expense",
 
    render: (deal) =>
      deal.actual_expense
        ? `₹${Number(deal.actual_expense).toLocaleString()}`
        : "₹0",
 
    exportValue: (deal) => deal.actual_expense || 0,
  },
 
  {
    id: "profit",
    label: "Profit",

    render: (deal) => {
      const revenue = Number(deal.deal_amount || 0);
      const expense = Number(deal.actual_expense || 0);
      const profit =
        deal.actual_profit !== undefined && deal.actual_profit !== null
          ? Number(deal.actual_profit)
          : (deal.profit !== undefined && deal.profit !== null
              ? Number(deal.profit)
              : revenue - expense);

      return `₹${profit.toLocaleString("en-IN")}`;
    },

    exportValue: (deal) => {
      if (deal.actual_profit !== undefined && deal.actual_profit !== null) {
        return Number(deal.actual_profit);
      }
      if (deal.profit !== undefined && deal.profit !== null) {
        return Number(deal.profit);
      }
      return Number(deal.deal_amount || 0) - Number(deal.actual_expense || 0);
    },
  },
 
{
  id: "status",
  label: "Status",

  render: (deal) => {
    return (
      <span
        className={`deal-status ${getDealStatusBadgeClass(deal.status)}`}
      >
        {deal.status || "-"}
      </span>
    );
  },

  exportValue: (deal) => deal.status || "",
},
 
  {
    id: "created_at",
    label: "Created",
 
    render: (deal) =>
      deal.lead?.created_at
        ? new Date(deal.lead.created_at).toLocaleDateString()
        : "-",
 
    exportValue: (deal) => deal.lead?.created_at || "",
  },
 
  {
    id: "owner",
    label: "Owner",
 
    render: (deal) =>
      deal.assigned_user ||
      deal.creator?.name ||
      "-",
 
    exportValue: (deal) =>
      deal.assigned_user ||
      deal.creator?.name ||
      "",
  },
];
 

 